import React from 'react';
import { useGetIdentity } from '@refinedev/core';
import { User } from '@src/types';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router';
import { SmartDataTable } from '@src/components/SmartDataTable';
import { useOrganizationCardView, useOrganizationsColumns,  useOrganizationsFormFields   } from './hooks';
import { AntdErrorBoundary } from '@src/components/AntdErrorBoundary';

export const OrganizationsPage: React.FC = () => {
  const { data: user, isLoading } = useGetIdentity<User>();
  const navigate = useNavigate();
  const columns = useOrganizationsColumns();
  const formFields = useOrganizationsFormFields();
  const { OrganizationCardView } = useOrganizationCardView(); 

  // Check user access
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <div>Loading...</div>
      </div>
    );
  }

  if (user?.type !== 'MASTER_ADMIN') {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="Sorry, you don't have permission to access the Organizations page."
        extra={[
          <Button
            type="primary"
            key="dashboard"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>,
        ]}
      />
    );
  }

  return (
    <AntdErrorBoundary>
      <SmartDataTable
        api={{
          resource: 'organizations',
        }}
        title="Organizations"
        columns={columns}
        search={{
          enabled: true,
          fields: ['id', 'name', 'contact_email', 'contact_mobile_no'],
          placeholder: 'Search by ID, name, email, or mobile...',
          debounceMs: 500,
        }}
        createForm={{
          fields: formFields as any,
          title: 'Create Organization',
          submitText: 'Create Organization',
        }}
        editForm={{
          fields: formFields as any,
          title: 'Edit Organization',
          submitText: 'Save Changes',
        }}
        formDisplayMode="modal"
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        pageSize={10}
        showSizeChanger={true}
        showQuickJumper={false}
        // showExport={true}
        showColumnVisibility={true}
        mobileCardComponent={OrganizationCardView}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 240px)',
          },
        }}
        rowKey="id"
      />
    </AntdErrorBoundary>
  );
};
